export const ANALYTICS_DOUBLE_ROLE_WARNING =
  'Текущему пользователю подключено две роли в настройках аккаунта. ' +
  'Функционал для отображения аналитики пользователя с двойной ролью будет доступен в следующих релизах.';
export const ANALYTICS_NO_ROLE_WARNING = 'Текущему пользователю не подключено ни одной роли в настройках аккаунта.';
export const ANALYTICS_GO_TO_ACCOUNT = 'Перейти в настройки аккаунта';
